// Staging configuration
// Change IS_STAGING to false when ready to launch the production site

export const IS_STAGING = false;

// Password to share with your client for site access
// Change this to whatever password you want to share
export const STAGING_PASSWORD = "masonrypro#1";
